type TimelineItem = {
  time: string;
  title: string;
  desc: string;
  source: string;
};

export default function Timeline({ items }: { items: TimelineItem[] }) {
  return (
    <ol className="relative border-l border-background-400 pl-6">
      {items.map((item, index) => (
        <li key={`${item.time}-${item.title}`} className="relative pb-8 last:pb-0">
          <span className="absolute -left-[31px] flex h-6 w-6 items-center justify-center rounded-full border border-background-400 bg-background-50">
            <span className="flex h-2.5 w-2.5 items-center justify-center rounded-full bg-accent-500" />
          </span>
          <div className="flex flex-wrap items-center gap-2">
            <span className="font-label text-xs font-semibold text-accent-700">{item.time}</span>
            <span className="font-label text-[11px] text-foreground-400">
              步骤 {String(index + 1).padStart(2, "0")}
            </span>
          </div>
          <h3 className="mt-1.5 font-heading text-base font-semibold text-foreground-950">
            {item.title}
          </h3>
          <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
          <p className="mt-2 inline-flex items-center gap-1.5 font-label text-[11px] text-foreground-500">
            <i className="ri-record-circle-line" /> {item.source}
          </p>
        </li>
      ))}
    </ol>
  );
}